var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-app",
    [
      _c(
        "icon-font-wrapper",
        [
          _c(
            "v-toolbar",
            {
              attrs: { id: "sb-header", app: "", dense: "", "clipped-left": "" }
            },
            [
              _c(
                "a",
                {
                  staticClass: "sphere-logo",
                  attrs: { href: "" + _vm.SbBaseUrl }
                },
                [
                  _c("img", {
                    attrs: {
                      src:
                        _vm.SbBaseUrl +
                        "/images/SPHEREboard_Logo_2024_white.svg",
                      height: "40",
                      alt: "SPHEREboard"
                    }
                  })
                ]
              ),
              _vm._v(" "),
              _c("v-toolbar-title", { attrs: { id: "MainHeaderTitle" } }, [
                _c("span", [_vm._v(_vm._s(_vm.$route.meta.title))]),
                _vm._v(" "),
                !!_vm.subHeadingText
                  ? _c("span", [_vm._v(" : " + _vm._s(_vm.subHeadingText))])
                  : !!_vm.$route.meta.subHeader
                  ? _c("span", [
                      _vm._v(
                        "\n          : " +
                          _vm._s(_vm.$route.meta.subHeader) +
                          "\n        "
                      )
                    ])
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c("v-spacer"),
              _vm._v(" "),
              _c("global-search-control", {
                on: { assetselected: _vm.getSelectedAsset }
              }),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  staticClass: "header-icon-button mr-0",
                  attrs: {
                    id: "user-guide",
                    href:
                      "https://docs.sphereco.com/sphereboard-" +
                      _vm.quickHelpVersion +
                      "-user-guides",
                    target: "_blank",
                    icon: "",
                    dark: ""
                  }
                },
                [
                  _c(
                    "v-tooltip",
                    {
                      attrs: { bottom: "" },
                      scopedSlots: _vm._u([
                        {
                          key: "activator",
                          fn: function(ref) {
                            var on = ref.on
                            var attr = ref.attr
                            return [
                              _c(
                                "v-icon",
                                _vm._g(
                                  _vm._b(
                                    { staticClass: "material-icons-outlined" },
                                    "v-icon",
                                    attr,
                                    false
                                  ),
                                  on
                                ),
                                [
                                  _vm._v(
                                    "\n              help_outline\n            "
                                  )
                                ]
                              )
                            ]
                          }
                        }
                      ])
                    },
                    [_vm._v(" "), _c("span", [_vm._v("Open the user guide")])]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  staticClass: "header-icon-button",
                  attrs: {
                    id: "request-support",
                    href: "https://customer.sphereco.com/",
                    target: "_blank",
                    icon: "",
                    dark: ""
                  }
                },
                [
                  _c(
                    "v-tooltip",
                    {
                      attrs: { bottom: "" },
                      scopedSlots: _vm._u([
                        {
                          key: "activator",
                          fn: function(ref) {
                            var on = ref.on
                            var attr = ref.attr
                            return [
                              _c(
                                "v-icon",
                                _vm._g(
                                  _vm._b(
                                    { staticClass: "material-icons-outlined" },
                                    "v-icon",
                                    attr,
                                    false
                                  ),
                                  on
                                ),
                                [
                                  _vm._v(
                                    "\n              support_agent\n            "
                                  )
                                ]
                              )
                            ]
                          }
                        }
                      ])
                    },
                    [_vm._v(" "), _c("span", [_vm._v("Request Support")])]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("span", { attrs: { id: "currentUser" } }, [
                _vm._v(_vm._s(_vm.currentUser))
              ]),
              _vm._v(" "),
              _vm.showLogout
                ? _c(
                    "v-menu",
                    {
                      attrs: {
                        transition: "scale-transition",
                        "close-on-content-click": false,
                        "offset-y": ""
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "activator",
                            fn: function(ref) {
                              var on = ref.on
                              return [
                                _c(
                                  "v-icon",
                                  _vm._g({ attrs: { color: "white" } }, on),
                                  [
                                    _vm._v(
                                      "\n            " +
                                        _vm._s(
                                          _vm.isExpanded
                                            ? "expand_less"
                                            : "expand_more"
                                        ) +
                                        "\n          "
                                    )
                                  ]
                                )
                              ]
                            }
                          }
                        ],
                        null,
                        false,
                        4086782523
                      ),
                      model: {
                        value: _vm.isExpanded,
                        callback: function($$v) {
                          _vm.isExpanded = $$v
                        },
                        expression: "isExpanded"
                      }
                    },
                    [
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          staticClass: "sb-logout-btn",
                          attrs: { "data-cy": "sb-logout-btn" },
                          on: { click: _vm.logout }
                        },
                        [
                          _c(
                            "v-icon",
                            {
                              staticClass: "mr-2",
                              attrs: { small: "", "data-cy": "sb-logout-icon" }
                            },
                            [_vm._v("\n            logout\n          ")]
                          ),
                          _vm._v("\n          Log out\n        ")
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          !_vm.hideSidebar
            ? _c("main-layout-sidebar", {
                ref: "sidebar",
                attrs: { width: _vm.navDrawerWidth }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.displayLicenseWarning ? _c("license-alert") : _vm._e(),
          _vm._v(" "),
          _c(
            "v-content",
            { style: "padding-left: " + _vm.navDrawerWidth + "px;" },
            [
              _c(
                "v-container",
                { staticClass: "pa-2", attrs: { fluid: "" } },
                [
                  _c("the-offline-alert"),
                  _vm._v(" "),
                  _c("status-display-bar", {
                    attrs: { error: _vm.errorMessage }
                  }),
                  _vm._v(" "),
                  _c(
                    "v-dialog",
                    {
                      attrs: { "max-width": "500px", persistent: "" },
                      model: {
                        value: _vm.showIdleAlert,
                        callback: function($$v) {
                          _vm.showIdleAlert = $$v
                        },
                        expression: "showIdleAlert"
                      }
                    },
                    [
                      _c(
                        "v-card",
                        [
                          _c(
                            "v-card-text",
                            [
                              _c(
                                "v-layout",
                                [
                                  _c("v-flex", [
                                    _vm._v(
                                      "\n                  Session has been idle for " +
                                        _vm._s(_vm.appIdleAlertTime) +
                                        " minutes.\n                  Please click on OK to continue.\n                "
                                    )
                                  ])
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-card-actions",
                            [
                              _c("v-spacer"),
                              _vm._v(" "),
                              [
                                _c(
                                  "v-btn",
                                  {
                                    staticClass: "sb_btn_solid",
                                    attrs: { color: "success" },
                                    on: { click: _vm.closeIdleWarning }
                                  },
                                  [
                                    _vm._v(
                                      "\n                  OK\n                "
                                    )
                                  ]
                                )
                              ]
                            ],
                            2
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { class: _vm.wrapperClass }, [_c("router-view")], 1)
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("the-footer")
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }